import { DialogComponent } from '@theme/dialog';
import { AddEvent } from '@theme/events';

/**
 * A custom element that manages a  drawer.
 *
 * @extends {DialogComponent}
 */
class DrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(AddEvent.eventName, this.#handleAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(AddEvent.eventName, this.#handleAdd);
  }

  #handleAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close  drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('-drawer-component')) {
  customElements.define('-drawer-component', DrawerComponent);
}
